export default "__VITE_ASSET__C9BpgAhN__"